import { useState,useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { AttendeeAndPresenterProvider } from '../context/AttendeeAndPresenterProvider';
import Controls from './Controls';
import QuestionComponent from './QuestionComponent';
import { validateMeetingId } from '../../utils/validateMeetingID';
import LoadingComponent from '../common/LoadingComponent';

const Presenter = ({ isReadOnly }) => {
  const { meetingId } = useParams();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {

    if (meetingId) {
      validateMeetingId(meetingId).then(()=> setLoaded(true));
    }
  }, [meetingId]);

  if(!loaded){
    return <LoadingComponent/>
  }

  return (
    <AttendeeAndPresenterProvider meetingId={meetingId}>
      <div className="flex-center direction-column" style={{ padding: 50 }}>
        <QuestionComponent isReadOnly={isReadOnly} />
        {!isReadOnly && <Controls />}
      </div>
    </AttendeeAndPresenterProvider>
  );
};


export default Presenter;
